import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Managment } from '../interfaces/managment';

@Injectable({
  providedIn: 'root'
})
export class ManagmentService {
  private myAppUrl: string;
  private myApiUrl: string;

  constructor(private http: HttpClient) {
    this.myAppUrl = environment.endpoint;
    this.myApiUrl = 'api/managments/'
  }
  getListManagments(): Observable<Managment[]> {

      return this.http.get<Managment[]>(`${this.myAppUrl}${this.myApiUrl}`);
     }
   
     deleteManagment(id: number): Observable<void> {
       return this.http.delete<void>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     saveManagment(managment: Managment): Observable<void> {
       return this.http.post<void>(`${this.myAppUrl}${this.myApiUrl}`,managment)
     }
   
     getManagment(id: number): Observable<Managment> {
       return this.http.get<Managment>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     updateManagment(id: number, managment: Managment): Observable<void> {
       return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}${id}`, managment);
     }
   }